import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Container } from 'ui/gridSystem';
import Modal, { stopEvent } from 'ui/components/Modals/Modal';

import { ModalGlobalContainer } from 'ui/components/Modals/Modal.style';

import Img from 'ui/assets/img/error.png';
import { MODAL_CLOSE } from 'redux/actions';
import ProDisplay from 'ui/typography/proDisplay';
import { Title, Subtitle, ContentWrapper, Icon, Image } from './style';

import { ModalWrapper } from '../InviteFriendModal/style';

const modalId = 'ui/components/ModalErrors';

const ModalErrors = ({ errorTitle, errorText, onClose }) => (
  <Modal id={modalId}>
    <Container>
      <ModalWrapper>
        <ModalGlobalContainer onMouseDown={stopEvent} onClick={stopEvent}>
          <ContentWrapper>
            <Icon className="icon-close-x" onClick={onClose} />
            <Image src={Img} />
            <Title>
              <ProDisplay type="modalTitle">
                {errorTitle || 'Errore'}
              </ProDisplay>
            </Title>
            <Subtitle>
              <ProDisplay
                configuration={{
                  lineHeight: 1.5,
                  letterSpacing: '0.25px',
                  fontSize: '18'
                }}
              >
                {errorText || "Si è verificato errore imprevisto. Ci scusiamo per il disagio"}
              </ProDisplay>
            </Subtitle>
          </ContentWrapper>
        </ModalGlobalContainer>
      </ModalWrapper>
    </Container>
  </Modal>
);

ModalErrors.propTypes = {
  // HOC (connect, state)
  errorText: PropTypes.string,
  errorTitle: PropTypes.string,

  // HOC (connect, dispatch)
  onClose: PropTypes.func.isRequired
};

ModalErrors.id = modalId;

export default connect(
  state => ({
    errorText: state.modal.payload?.errorText,
    errorTitle: state.modal.payload?.errorTitle
  }),
  dispatch => ({
    onClose: () => dispatch({ type: MODAL_CLOSE })
  })
)(ModalErrors);
